import * as cx from 'classnames';
import * as React from 'react';

type Placement = 'top' | 'right' | 'bottom' | 'left';

interface OwnProps {
    className?: string;
    placement?: Placement;
    positionLeft?: number;
    positionTop?: number;
    arrowOffsetLeft?: number | string;
    arrowOffsetTop?: number | string;
    title?: React.ReactNode;
    style?: any;
}

const Popover: React.StatelessComponent<OwnProps> = ({
    className, placement, positionLeft, positionTop, arrowOffsetLeft, arrowOffsetTop,
    title, style, children,
}) => {
    const classes = {
        popover: true,
        [placement]: true,
    };

    const allStyles = {
        left: positionLeft,
        top: positionTop,
        display: 'block',
        ...style,
    };

    const arrowStyle = {
        left: arrowOffsetLeft,
        top: arrowOffsetTop,
    };

    return (
        <div role="tooltip" className={cx(className, classes)} style={allStyles}>
            <div className="arrow" style={arrowStyle} />
            {title ? <h3 className="popover-title">{title}</h3> : null}
            <div className="popover-content">
                {children}
            </div>
        </div>
    );
};

export default Popover;
